import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  MainPageNotificationItem,
  MainPageSaleSummaryItem,
  MembershipSummary,
  Notification,
  SaleDashboardResponse,
  UrgentAnnouncement
} from '../../models/main-page.model';
import { ShiftSchedule } from '../../models/shift-schedule.model';

export const mainPageAction = createActionGroup({
  source: 'Main Page',
  events: {
    notificationRequest: props<{ notifications: Notification[] }>(),
    notificationResponse: props<{ data: MainPageNotificationItem }>(),
    summaryRequest: emptyProps(),
    summaryResponse: props<{ data: MainPageSaleSummaryItem }>(),
    membershipSummaryRequest: emptyProps(),
    membershipSummaryResponse: props<{ data: MembershipSummary }>(),
    shiftScheduleRequest: emptyProps(),
    shiftScheduleResponse: props<{ data: ShiftSchedule[] }>(),
    dashboardOverviewRequest: emptyProps(),
    dashboardOverviewResponse: props<{ data: SaleDashboardResponse }>(),
    urgentAnnouncementRequest: emptyProps(),
    urgentAnnouncementResponse: props<{ data: UrgentAnnouncement | null }>(),
    resetData: emptyProps()
  }
});
